import { render, staticRenderFns } from "./GroupListHome.vue?vue&type=template&id=0be4486a&"
import script from "./GroupListHome.vue?vue&type=script&lang=ts&"
export * from "./GroupListHome.vue?vue&type=script&lang=ts&"
import style0 from "./GroupListHome.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports